<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="1000px"
      v-bind:body-style="{ height: '480px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row >
          <a-col :span = "12">
            <a-form-model-item label="实体卡名称:" prop="cardName">
            <a-input v-model="searchList.cardName" :allowClear="true" placeholder="请输入实体卡名称"/>
          </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="卡类别:" prop="cardType">
              <a-select v-model="searchList.cardType" placeholder="请选择卡类别">
                <a-select-option v-for="item in cardTypeList" :key="item.value" :value="item.value" style="width: 120px">
                    {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="定价:" prop="cardPrice">
            <a-input type="number" suffix="元" v-model="searchList.cardPrice"
                    placeholder="请输入定价" />
          </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="折扣比率:" prop="cardRebate">
              <a-select v-model="searchList.cardRebate"  placeholder="请选择折扣比率">
              <a-select-option v-for="item in discounts" :key="item.value" :value="item.value" style="width: 120px">
                  {{ item.label }}
              </a-select-option>
          </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="状态:" prop="status">
              <a-radio-group v-model="searchList.status" >
                <a-radio :value="'1'">
                  启用
                </a-radio>
                <a-radio :value="'2'">
                  禁用
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="说明:" prop="remark">
              <a-textarea :row="4" v-model="searchList.remark" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item
              label="配图"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              required
            >
              <upload  :downid="cardId" uploadNum="1" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="cancel-color" ghost @click="handleCancel">取消</a-button>
      <a-button  class="btn-color" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import upload from "@/components/upload/upload.vue";
import { DictionaryService } from '@common/services/dictionary.service'
import{
  getId, addPhyCard,updatePhyCard,detailPhyCard
} from "@/api/api.js";
export default {
  components: { upload },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    
    cardId: {type: String},//新增实体卡ID
    data: {
      type: Array,
      default: () => [],
    },//返回信息
  },
  data() {
    //自定义校验规则
    var checkPrice = (rule, value, callback) => {
      if (value) {
        if (Number(value) <= 0) {
            return callback(new Error('请输入大于0的数'));
        } else if (Number(value) > 99999999) {
          return callback(new Error('定价不能超过8位数'));
        } else if(!/^\d+\.*\d{0,2}$/ig.test(value)){
          return callback(new Error('输入不能超过两位小数'));
        }
      } else {
        return callback();
      }
      return callback();
    };
    return {
      id: "",
      uploadAgain: false,
      fileNum: 0,
      imgUrl :'',
      imgId :[],
      visible: true,
      discounts:[],
      useStatus:[],
      cardTypeList:[],
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      okLoad: false,

      //绑定值
      searchList: {
        id: this.cardId,
        cardName: "",
        cardType:"",
        cardPrice:"",
        cardRebate: undefined,
        remark:"",
        status: "1",
        imgUrl:""
      },

      //校验规则
      rules: {
        cardName: [
          {
            required: true,
            message: "实体卡名称不能为空！",
            trigger: "blur",
          },
          {
            max: 90,
            message: "不可超过90字",
            trigger: "blur",
          }
        ],
        cardType: [
          {
            required: true,
            message: "请选择卡类别",
            trigger: "change",
          }
        ],
        cardPrice: [
          {
            required: true,
            message: "实体卡定价不能为空！",
            trigger: "blur",
          },
          {
            validator: checkPrice,
            trigger: "change",
          }
        ],
        cardRebate: [
          {
            required: true,
            message: '请选择卡折扣',
            trigger: 'change',
          }
        ],
        remark: [
          {
            required: true,
            message: "说明不能为空！",
            trigger: "blur",
          },
          {
            max: 200,
            message: "不可超过200字",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态！",
            trigger: "change",
          },
        ],
      },

      //网点编号是否可以修改
      netDisabled:false,
    }
  },
  mounted() {
    DictionaryService.getAllNeedDic(["GOODS_DISCOUNT", "USE_STATUS", "CARD_TYPE", "GOODS_EXPIRY_DATE"]).then((res) => {
      this.discounts = DictionaryService.getOptions("GOODS_DISCOUNT");
      this.useStatus = DictionaryService.getOptions("USE_STATUS");
      this.cardTypeList = DictionaryService.getOptions("CARD_TYPE");

      if (this.modalTitle == '编辑实体卡信息') {
        this.netDisabled = true;
        detailPhyCard({id: this.cardId}).then(
          (res) => {
            if (res.code == '0000') {
              this.searchList = res.content;
              this.searchList.imgUrl = res.content.attachments[0].busId;
            }
          },
          (err) => {
            this.$message.error('查询实体信息失败')
          }
        )
      } else {
        //下拉框默认值
        this.searchList.cardRebate = this.discounts[0].value;
        this.searchList.cardType = this.cardTypeList[0].value;
      }
      this.searchList.id = this.cardId; 
    });
},
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      //弹窗确定
      //校验图片
      if (this.searchList.imgUrl == "" || this.searchList.imgUrl == null || this.searchList.imgUrl == undefined) {
        return this.$message.warning("请上传配图！")
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.okLoad = true
          if (this.modalTitle == '添加实体卡信息') {
            addPhyCard(this.searchList).then(
              (res) => {
                if (res.code == '0000') {
                  this.okLoad = false;
                  this.$message.success('新增成功');
                  this.$emit('handleOk');
                }
              },
              (err) => {
                this.okLoad = false
                this.$message.error('新增失败')
              }
            )
          } else {
            updatePhyCard(this.searchList).then(
              (res) => {
                if (res.code == '0000') {
                  this.okLoad = false;
                  this.$message.success('修改成功');
                  this.$emit('handleOk');
                }
              },
              (err) => {
                this.okLoad = false
              }
            )
          }
        };
      })
    },

    //监听附件组件
    listen(val) {
      this.uploadAgain = false;
      if(val.length == 0){
        this.imgUrl = false;
        this.searchList.imgUrl ="";
      } else {
        this.imgUrl = true;
        this.imgId = val[0].id;
        this.searchList.imgUrl = val[0].id;
        this.uploadAgain = true;//监听是否已上传文件
      }
      this.fileNum = val.length;
    },

  },
}
</script>

<style scoped>
.btn-color {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}
.cancel-color{
  border-color: rgba(22, 130, 139, 1);
  color: rgba(22, 130, 139, 1);
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
